import styled from "@emotion/styled";

import { MergeWithOverwrite } from "src/common";
import { colors } from "src/theme";

const IconSpan = styled.span((props: { height: number, width: number }) => ({
  display: 'inline-flex',
  height: props.height,
  width: props.width,
}))

export type RemoveIconProps = MergeWithOverwrite<React.HtmlHTMLAttributes<HTMLSpanElement>, {
  width?: number,
  height?: number,
  color?: string,
}>;

export const RemoveIcon: React.FC<RemoveIconProps> = ({ width = 20, height = 20, color = colors.primary, ...props }) => (
  <IconSpan {...props} height={height} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
      <path d="M6.34535 16.6684C5.97244 16.6684 5.6548 16.5373 5.39244 16.2751C5.13022 16.0127 4.9991 15.6951 4.9991 15.3221V5.00172H4.16577V4.16839H7.4991V3.52734H12.4991V4.16839H15.8324V5.00172H14.9991V15.3221C14.9991 15.7057 14.8706 16.026 14.6137 16.283C14.3567 16.5399 14.0365 16.6684 13.6529 16.6684H6.34535ZM14.1658 5.00172H5.83244V15.3221C5.83244 15.4717 5.88049 15.5946 5.9766 15.6909C6.07285 15.787 6.19577 15.8351 6.34535 15.8351H13.6529C13.7812 15.8351 13.8988 15.7816 14.0056 15.6748C14.1124 15.568 14.1658 15.4505 14.1658 15.3221V5.00172ZM8.17223 14.1684H9.00556V6.66839H8.17223V14.1684ZM10.9926 14.1684H11.826V6.66839H10.9926V14.1684Z" fill={color} />
    </svg>
  </IconSpan>
);
